<template>
    <MainContainer>
        <template v-slot:sidebar>&nbsp;</template>
        <div class="benutzerverwaltung">
            <h2>Benutzerverwaltung</h2>
            <h3>
                Gruppen
                <b-button v-if="checkRight('write')" :size="size" @click="dataCreate">
                    Neu
                    <font-awesome-icon icon="plus" />
                </b-button>
            </h3>
            <Table
                bordered
                striped
                small
                showFilter
                :fields="fields"
                :items="items"
                :isBusy="busy"
                busyText="Lädt Gruppen..."
                emptyText="Keine Gruppen gefunden"
            >
                <template v-slot:actions="{ row: row }">
                    <b-button
                        v-if="checkRight('write')"
                        :size="size"
                        variant="link"
                        @click="dataSelected(row)"
                        class="mv-table-action-btn mr-1"
                    >Bearbeiten</b-button>
                    <b-button
                        v-if="checkRight('delete')"
                        :size="size"
                        @click="dataDelete(row)"
                        variant="link"
                        class="text-danger mv-table-action-btn"
                    >Löschen</b-button>
                </template>
            </Table>
            <EditModal
                :title="selected.title"
                :busy="selected.busy"
                id="newModal"
                buttonText="Anlegen"
                @ok="dataProvide"
                @hide="dataHide"
            >
                <template v-if="selected.data">
                    <FormGroupBuilder
                        :fields="ioFields.new"
                        :data="selected.data"
                        :refresh="validationRefresh"
                    />
                </template>
            </EditModal>
            <EditModal
                :title="selected.title"
                :busy="selected.busy"
                buttonText="Speichern"
                scrollable
                @ok="dataProvide"
                @hide="dataHide"
            >
                <b-tabs pills card vertical>
                    <b-tab title="Benutzer" active>
                        <template v-if="selected.data">
                            <FormGroupBuilder
                                :fields="ioFields.edit"
                                :data="selected.data"
                                :refresh="validationRefresh"
                            />
                        </template>
                    </b-tab>
                    <b-tab title="Rechte" disabled>
                        Coming soon...
                        <!--<Tree :items="accessMap.data" @update="updateAccessMap" />-->
                    </b-tab>
                    <b-tab title="Zuweisung" disabled>Coming soon...</b-tab>
                </b-tabs>
            </EditModal>
            <RemoveModal
                :title="selected.title"
                :busy="selected.busy"
                @ok="dataProvide"
                @hide="dataHide"
            />
        </div>
    </MainContainer>
</template>

<script>
import CommonView from "@/mixins/CommonView/CommonView";
import Size from "@/mixins/Size/Size";
import Validation from "@/mixins/Validation/Validation";
import { ApiFactory } from "@/api/ApiFactory.js";
import MainContainer from "@/components/MainContainer/MainContainer";
import Table from "@/components/Table/Table";
import EditModal from "@/components/EditModal/EditModal";
import RemoveModal from "@/components/RemoveModal/RemoveModal";
import FormGroupBuilder from "@/components/FormGroupBuilder/FormGroupBuilder";
import UserSettings from "@/components/UserSettings/UserSettings";

const BenutzerverwaltungApi = ApiFactory.get("benutzerverwaltung");

export default {
    name: "benutzergruppen",
    mixins: [CommonView, Size, Validation],
    components: {
        MainContainer,
        Table,
        EditModal,
        RemoveModal,
        FormGroupBuilder
    },
    data() {
        return {
            fields: [
                {
                    key: "id",
                    label: "ID",
                    sortable: true
                },
                {
                    key: "slug",
                    label: "Kürzel"
                },
                {
                    key: "nicename",
                    label: "Bezeichnung",
                    sortable: true
                },
                {
                    key: "actions",
                    label: "Funktionen",
                    class: "text-center"
                }
            ],
            ioFields: {
                new: [
                    {
                        key: "slug",
                        label: "Kürzel",
                        description:
                            "Kurzform der Rechtebeschreibung (Es sind keine Leerzeichen oder Groß- und Kleinschreibung erlaubt)"
                    },
                    {
                        key: "nicename",
                        label: "Bezeichnung",
                        description: "Beschreibung der Gruppe"
                    }
                ],
                edit: [
                    {
                        key: "id",
                        label: "ID",
                        type: "text",
                        disabled: true,
                        oneWay: true
                    },
                    {
                        key: "slug",
                        label: "Kürzel",
                        description:
                            "Kurzform der Rechtebeschreibung (Es sind keine Leerzeichen oder Groß- und Kleinschreibung erlaubt)"
                    },
                    {
                        key: "nicename",
                        label: "Bezeichnung",
                        description: "Beschreibung der Gruppe"
                    }
                ]
            },
            api: BenutzerverwaltungApi
        };
    },
    methods: {
        async fetch() {
            this.busy = true;
            const response = await this.api.getGroups();
            if (response.ok) {
                var items = response.json.collection;
                items = items.map(item => this.process(item));
                this.items = items;
                this.registerRights(response);
            }
            this.busy = false;
        },
        dataCreate() {
            const newObj = {};
            this.dataSet(newObj, "new", "Neu erstellen");
            this.$root.$emit("bv::show::modal", "newModal");
        },
        async dataProvide(evt) {
            evt.preventDefault();
            var selectedItem = this.selected.data;

            if (selectedItem) {
                // TODO: Validation
                this.selected.busy = true;
                var response = null;

                if (this.selected.action === "new") {
                    response = await this.api.postGroup(selectedItem);
                } else if (this.selected.action === "remove") {
                    response = await this.api.deleteGroup(selectedItem.id);
                } else {
                    response = await this.api.putGroup(
                        selectedItem.id,
                        selectedItem
                    );
                }

                var additionalResponse = true;
                if (
                    this.selected.action !== "new" &&
                    this.selected.action !== "remove"
                ) {
                    additionalResponse = await this.additionalRequests(
                        selectedItem
                    );
                }

                if (response.ok && additionalResponse) {
                    var currentItems = [...this.items];
                    if (this.selected.action === "new") {
                        selectedItem = this.postProcessCreate(
                            selectedItem,
                            response
                        );
                        currentItems.push(selectedItem);
                    } else if (this.selected.action === "remove") {
                        selectedItem = this.postProcessRemove(
                            selectedItem,
                            response
                        );
                        currentItems = currentItems.filter(item => {
                            return item.id !== selectedItem.id;
                        });
                    } else {
                        selectedItem = this.postProcessEdit(
                            selectedItem,
                            response
                        );
                        var changedIndex = currentItems.findIndex(item => {
                            return item.id === selectedItem.id;
                        });
                        currentItems[changedIndex] = selectedItem;
                    }

                    this.items = currentItems;

                    this.dataSet();
                    this.$root.$emit("bv::hide::modal", "newModal");
                    this.$root.$emit("bv::hide::modal", "editModal");
                    this.$root.$emit("bv::hide::modal", "removeModal");
                    this.makeToast(
                        "Erfolgreich gespeichert",
                        "Die Änderungen wurden erfolgreich in der Datenbank gespeichert"
                    );
                } else {
                    if (this.selected.action === "new") {
                        this.handleValidationData(response, this.ioFields.new);
                    } else {
                        this.handleValidationData(response, this.ioFields.edit);
                    }

                    this.fetchErrorHandling(response);
                }
                this.selected.busy = false;
            }
        },
        postDataSet() {
            this.cleanValidationData(this.ioFields.new);
            this.cleanValidationData(this.ioFields.edit);
        }
    }
};
</script>
